import {
  withAiSummaryDates,
  withRebalanceDates,
  withOptimizeDates,
  withIntradayDates,
} from "../adapters"

// Screen components
import RebalanceModule from "modules/rebalance"
import Optimization from "modules/optimization"
import ExperimentsModule from "modules/experiments"
import AssetAnalytics from "modules/asset-analytics"
import AnalyzeFactors from "modules/analyze-factors"
import Intraday from "modules/intraday"
import AnalyzePerformance from "modules/analyze-performance"
import AnalyzeHistoricalExposure from "modules/analyze-historical-exposure"
import AnalyzeComposition from "modules/analyze-composition"
import AnalyzeRisk from "modules/analyze-risk"
import AnalyzeForecast from "modules/analyze-forecast"
import AnalyzeFactorSensitivity from "modules/analyze-factor-sensitivity"
import OverviewPerformance from "modules/overview-performance"
import OverviewRisk from "modules/risk"
import EditExperiment from "modules/edit-experiment"
import PortfolioCompareAdapter from "modules/portfolio-compare-adapter"

// Rebalance screens
export const WrappedRebalanceModule = withRebalanceDates(RebalanceModule)
export const WrappedOptimization = withOptimizeDates(Optimization)
export const WrappedIntradayRebalance = withIntradayDates(RebalanceModule)
export const WrappedExperimentsModule = withAiSummaryDates(ExperimentsModule)

// Analyze screens
export const WrappedAssetAnalytics = withAiSummaryDates(AssetAnalytics)
export const WrappedAnalyzeFactors = withAiSummaryDates(AnalyzeFactors)
export const WrappedIntraday = withIntradayDates(Intraday)

// Trends screens
export const WrappedAnalyzePerformance = withAiSummaryDates(AnalyzePerformance)
export const WrappedAnalyzeHistoricalExposure = withAiSummaryDates(AnalyzeHistoricalExposure)
export const WrappedAnalyzeComposition = withAiSummaryDates(AnalyzeComposition)
export const WrappedAnalyzeRisk = withAiSummaryDates(AnalyzeRisk)
export const WrappedAnalyzeForecast = withAiSummaryDates(AnalyzeForecast)
export const WrappedAnalyzeFactorSensitivity = withAiSummaryDates(AnalyzeFactorSensitivity)

// Overview screens
export const WrappedOverviewPerformance = withAiSummaryDates(OverviewPerformance)
export const WrappedOverviewRisk = withAiSummaryDates(OverviewRisk)

// Experiments
export const WrappedEditExperiment = withAiSummaryDates(EditExperiment)

// Compare
export const WrappedPortfolioCompareAdapter = withAiSummaryDates(PortfolioCompareAdapter)
